import gql from 'graphql-tag';

export const GroupListQuery = gql`
  query getGroupList {
    me {
      userProfile {
        id
        name
        avatarUrl
        topContacts(first: 200) {
          contacts {
            id
            email
            name
            avatarUrl
          }
        }
      }
      groups {
        id
        name
        emoji
        isAdmin
        groupType
        members {
          ... on Person {
            id
            email
            name
            avatarUrl
          }
        }
      }
      organization {
        id
        name
        type
      }
      orgGroup {
        id
        name
        groupType
        members {
          ... on Person {
            id
            name
            email
            avatarUrl
          }
        }
      }
      otherPeople {
        id
        name
        email
        avatarUrl
      }
    }
  }
`;
